import _ from 'lodash';
import SphConstants from 'sg-sph-constants';

const isHomeTailormade = (model, isModelValue) => {
    const lobData = isModelValue ? model.lobData : model.value.lobData;
    const isOverRebuildThreshold = _.get(lobData.privateHome.coverables.propertyDetails.rebuildCost, 'amount')
        > SphConstants.SG_HOME_TAILORMADE_LIMITS.REBUILD_COST;
    const isOverContentsThreshold = lobData.privateHome.coverables.propertyDetails.contentsTotal
        && lobData.privateHome.coverables.propertyDetails.contentsTotal.amount
        > SphConstants.SG_HOME_TAILORMADE_LIMITS.CONTENTS;
    const hasSelectedMoreThanThreshold = _.get(model, 'lobData.privateHome.coverables.propertyDetails.contentsCoverValue.value.code')
        === SphConstants.MORE_THAN_100K_KEY;
    return isOverContentsThreshold || isOverRebuildThreshold || hasSelectedMoreThanThreshold;
};

const isLandlord = (model, isModelValue) => {
    const lobData = isModelValue ? model.lobData : model.value.lobData;
    return lobData.privateHome.coverables.propertyDetails.propertyUse === SphConstants.PROPERTY_USE_CODES.Let;
};

const isHolidayHome = (modelVM) => {
    const { propertyUse } = modelVM.value.lobData.privateHome.coverables.propertyDetails;
    return propertyUse === SphConstants.PROPERTY_USE_CODES.LetHolidayHome || propertyUse === SphConstants.PROPERTY_USE_CODES.FamilyHolidayHome
        || propertyUse === SphConstants.PROPERTY_USE_CODES.WeekendHome;
};

const getCoverLevelCode = (modelVM) => {
    return modelVM.lobData.privateHome.coverables.coverLevel.value.code;
};

const hasBuildingCover = (modelVM) => {
    const coverLevel = getCoverLevelCode(modelVM);
    return coverLevel === SphConstants.COVER_LEVEL.BUILDINGS_ONLY || coverLevel === SphConstants.COVER_LEVEL.BUILDINGS_AND_CONTENTS;
};

const hasContentsCover = (modelVM) => {
    const coverLevel = getCoverLevelCode(modelVM);
    return coverLevel === SphConstants.COVER_LEVEL.CONTENTS_ONLY || coverLevel === SphConstants.COVER_LEVEL.BUILDINGS_AND_CONTENTS;
};

const hasCombinedCover = (modelVM) => {
    const coverLevel = getCoverLevelCode(modelVM);
    return coverLevel === SphConstants.COVER_LEVEL.BUILDINGS_AND_CONTENTS;
};

const getAllCoverages = (modelVM) => {
    const { coverages } = modelVM.lobData.privateHome.offerings.value[0];
    return [
        ...coverages.addOnsCoverages,
        ...coverages.basicCoverages,
        ...coverages.contentsExtensionCoverages
    ];
};

const getCoverage = (modelVM, coverageCode) => {
    const coverages = getAllCoverages(modelVM);
    return _.find(coverages, (coverage) => coverage.patternCode === coverageCode);
};

const hasSheCoverAdded = (modelVM) => {
    const sheCover = getCoverage(modelVM, SphConstants.COVERAGES_CODES.HomeEmergency);
    return sheCover && sheCover.selected;
};

const hasBoilerCoverAdded = (modelVM) => {
    const boilerCover = getCoverage(modelVM, SphConstants.COVERAGES_CODES.BoilerService);
    return boilerCover && boilerCover.selected;
};

const hasLegalCoverAdded = (modelVM) => {
    const legalCover = getCoverage(modelVM, SphConstants.COVERAGES_CODES.LegalExpenses);
    return legalCover && legalCover.selected;
};

const isSagaPlus = (modelVM) => {
    return modelVM.lobData.privateHome.offerings.value[0].coverages.isSagaPlus;
};

const basicCoverages = (modelVM) => {
    return _.get(modelVM.value || modelVM, 'lobData.privateHome.offerings[0].coverages.basicCoverages');
};

const ContentsOrBuildingsADCover = (value, termCode) => {
    let coverValue;
    let cover;
    if (termCode === SphConstants.COVERAGES_CODES.ContentsLevelTermName) {
        coverValue = value === `${SphConstants.COVERAGES_CODES.ContentsLevelTermName}_${SphConstants.COVER_LEVEL_HOMEAD}`;
        cover = SphConstants.HOME_ADDONS.HasContentsAccidentCover;
    }
    if (termCode === SphConstants.COVERAGES_CODES.BuildingLevelTermName) {
        coverValue = value === `${SphConstants.COVERAGES_CODES.BuildingLevelTermName}_${SphConstants.COVER_LEVEL_HOMEAD}`;
        cover = SphConstants.HOME_ADDONS.HasBuildingsAccidentCover;
    }
    return [cover, coverValue];
};

const getImportantInfoLink = (modelVM) => {
    if (isLandlord(modelVM)) {
        return SphConstants.POLICY_BOOKLET_URLS.IMPORTANT_INFORMATION_URL_LANDLORD;
    }
    if (isHomeTailormade(modelVM)) {
        return SphConstants.POLICY_BOOKLET_URLS.IMPORTANT_INFORMATION_URL_TAILORMADE;
    }
    return SphConstants.POLICY_BOOKLET_URLS.IMPORTANT_INFORMATION_URL;
};

export default {
    isHomeTailormade,
    isLandlord,
    isHolidayHome,
    getCoverLevelCode,
    hasBuildingCover,
    hasContentsCover,
    hasSheCoverAdded,
    hasBoilerCoverAdded,
    hasLegalCoverAdded,
    isSagaPlus,
    hasCombinedCover,
    basicCoverages,
    ContentsOrBuildingsADCover,
    getImportantInfoLink
};
